var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_2",
    "data-name": "Component 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1456",
    "data-name": "Rectangle 1456",
    width: 19,
    height: 19,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_47",
    "data-name": "Union 47",
    d: "M14.921,12.53a1,1,0,0,1-1-1V1a1,1,0,0,1,1-1H17.1a1,1,0,0,1,1,1V11.53a1,1,0,0,1-1,1ZM0,10.946V1.373A1.479,1.479,0,0,1,2.082.123L10.409,4.98a1.319,1.319,0,0,1,0,2.359L2.082,12.194a1.427,1.427,0,0,1-.711.2A1.4,1.4,0,0,1,0,10.946Z",
    transform: "translate(0.001 2.264)",
    fill: "#fafafa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.3a141dd2f0f744d0722338d1f4c5585a.svg";
export { ForwardRef as ReactComponent };